import { render, staticRenderFns } from "./PgaValutazioneOffertaPostsaleDetails.vue?vue&type=template&id=5eb7ade2&"
import script from "./PgaValutazioneOffertaPostsaleDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaPostsaleDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VDataTable,VForm,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eb7ade2')) {
      api.createRecord('5eb7ade2', component.options)
    } else {
      api.reload('5eb7ade2', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaPostsaleDetails.vue?vue&type=template&id=5eb7ade2&", function () {
      api.rerender('5eb7ade2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaPostsaleDetails.vue"
export default component.exports